import { X, ArrowsClockwise } from "@phosphor-icons/react";

export function HistoryModal({ historyModalRow, data, loadingAction, handleUndoChange, onClose }) {
  if (historyModalRow === null) return null;
  const row = data.find(r => r._id === historyModalRow);
  if (!row) return null;
  const rowId = row._id;
  const history = row._history || [];
  const name = `${row.vorname || ''} ${row.nachname || ''}`.trim() || 'Unbekannt';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 modal-overlay" onClick={onClose}>
      <div
        data-testid="history-modal"
        className="bg-popover border border-border rounded-lg shadow-xl w-full max-w-lg mx-4 flex flex-col max-h-[80vh] modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div>
            <h3 className="text-sm font-semibold">Änderungshistorie</h3>
            <p className="text-xs text-muted-foreground">{name}</p>
          </div>
          <button data-testid="close-history-modal" onClick={onClose} className="p-1 rounded hover:bg-secondary text-muted-foreground hover:text-foreground transition-colors">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 min-h-0">
          {history.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">Keine Änderungen vorhanden.</p>
          ) : (
            <div className="space-y-2">
              {[...history].reverse().map((entry, reverseIdx) => {
                const realIdx = history.length - 1 - reverseIdx;
                const dt = new Date(entry.timestamp);
                const dateStr = dt.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
                const timeStr = dt.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
                const canUndo = !!entry.field;
                return (
                  <div key={realIdx} className="flex items-start justify-between gap-2 py-2 border-b border-border/50 last:border-0">
                    <div className="flex-1 min-w-0">
                      <div className="flex gap-1.5 text-xs leading-tight">
                        <span className="text-muted-foreground whitespace-nowrap flex-shrink-0">{dateStr} - {timeStr}</span>
                        <span className="text-primary font-medium flex-shrink-0">{entry.user}:</span>
                      </div>
                      <p className="text-xs text-foreground mt-0.5">{entry.description}</p>
                    </div>
                    {canUndo && (
                      <button
                        data-testid={`undo-change-${realIdx}`}
                        onClick={() => handleUndoChange(rowId, realIdx)}
                        className="flex-shrink-0 flex items-center gap-1 px-2 py-1 text-[10px] font-medium rounded border border-border hover:bg-secondary hover:text-primary transition-colors text-muted-foreground"
                        title="Rückgängig machen"
                        disabled={loadingAction === `undo-${rowId}-${realIdx}`}
                      >
                        {loadingAction === `undo-${rowId}-${realIdx}` ? (
                          <div className="animate-spin h-3 w-3 border-2 border-primary border-t-transparent rounded-full" />
                        ) : (
                          <ArrowsClockwise className="h-3 w-3" />
                        )}
                        {loadingAction === `undo-${rowId}-${realIdx}` ? 'Wird rückgängig...' : 'Rückgängig'}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="p-3 border-t border-border flex justify-end">
          <button onClick={onClose} className="px-3 py-1.5 text-xs rounded bg-secondary text-foreground hover:bg-secondary/80 transition-colors">
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}
